import React, { useState, useEffect } from 'react'
import {
  Form,
  Pagination,
  Button,
  Modal,
  FormGroup,
  FormLabel,
  FormSelect,
  Container,
  Row,
  Col,
} from 'react-bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import Cookies from 'js-cookie'

import {
  FaUser,
  FaEye,
  FaEdit,
  FaTrash,
  FaChalkboardTeacher,
  FaSyncAlt,
} from 'react-icons/fa'
// import ApiEndpoints, {BASE_URL} from './commonComponents/ApiEndpoints'
import ApiEndpoints, {BASE_URL} from './commonComponents/ApiEndpoints'

import toast from 'react-hot-toast'
import EditTeacherModal from './EditTeacherModal'
import { Eye, PencilSquare } from 'react-bootstrap-icons'
import { FaEyeSlash } from 'react-icons/fa'
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table'
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import axios from 'axios'
import { useAuth } from './AuthContext'

const GuardianTable = () => {
  const { user } = useAuth()
  console.log('USER ', user)
  const { student_id: paramStudentId, course_id: paramCourseId, class_id: paramClassId } = useParams();
  const [errorMessage, setErrorMessage] = useState("");

  const [data, setData] = useState([])
  const [search, setSearch] = useState('')
  const [currentPage, setCurrentPage] = useState(1)
  const [itemsPerPage, setItemsPerPage] = useState(10)
  const [showModal, setShowModal] = useState(false)
  const [loading, setLoading] = useState(false)
  const [showEditModal, setShowEditModal] = useState(false)
  const [selectedTeacher, setSelectedTeacher] = useState(null)
  const [institute, setInstitute] = useState('')
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const [courses, setCourses] = useState([]);
    const [classes, setClasses] = useState([]);
    const [students, setStudents] = useState([]);
    console.log("Short Data students:", students)

    // State for selected values
    const [selectedCourse, setSelectedCourse] = useState('');
    const [selectedClass, setSelectedClass] = useState('');
    const [selectedStudent, setSelectedStudent] = useState('');
    const [selectedStudentFull, setSelectedStudentFull] = useState(null);
    const [selectedStudentId, setSelectedStudentId] = useState('');
    const [allStudents, setAllStudents] = useState([])

    const isFromURL = Boolean(paramStudentId && paramCourseId && paramClassId);

   // prefill when arriving with URL params
  useEffect(() => {
    if (isFromURL) {
      // store as strings (select value uses string)
      setSelectedCourse(String(paramCourseId));
      setSelectedClass(String(paramClassId));
      setSelectedStudentId(String(paramStudentId));
      // fetch parents for that student immediately
      fetchAllParents(paramStudentId);
    }
  }, [paramStudentId, paramCourseId, paramClassId]); // run once when route params available

  useEffect(() => {
    const instituteId = Cookies.get('institute_id')
    const instituteName = Cookies.get('institute_name')

    console.log('instituteId', instituteId)
    console.log('instituteName', instituteName)

    setInstitute({ instituteId, name: instituteName })
    setNewParent((prev) => ({
      ...prev,
      institute_id: instituteId,
    }))
  }, [])

  // useEffect(() => {
  //   const institueId = Cookies.get('institute_id')
  //   const userCookie = Cookies.get('user')
  //   let token = null
  //   console.log('InstituteID', institueId)

  //   if (userCookie) {
  //     try {
  //       const user = JSON.parse(userCookie)
  //       token = user.token
  //       console.log('TOKEN:', token)
  //     } catch (err) {
  //       console.error(' Failed to parse user cookie', err)
  //     }
  //   } else {
  //     console.warn('user cookie not found')
  //   }

  //   const fetchFilteredData = async () => {
  //     console.log('Insti ID: ', institueId)
  //     try {
  //       const headers = {
  //         'Content-Type': 'application/json',
  //         Authorization: `Bearer ${token}`,
  //         institute_id: Number(institueId),
  //       }

  //       console.log('Request Headers:', headers)

  //       const response = await axios.get(
  //         BASE_URL+'/parents',
  //         { headers },
  //       )

  //       console.log('Parents response: ', response.data.data)

  //       setData(response.data.data)
  //       // setFilteredData(response.data.data) // ✅ FIXED: show data in table
  //     } catch (error) {
  //       toast.error(error.response?.data?.message || 'Something went wrong')
  //     }
  //   }

  //   fetchFilteredData()
  // }, [loading])
 const fetchParents = async () => {
      const institueId = Cookies.get("institute_id");
      const userCookie = Cookies.get("user");
      let token = null;
      if (userCookie) {
        try {
          const user = JSON.parse(userCookie);
          token = user.token;
        } catch (err) {
          console.error("Failed to parse user cookie", err);
        }
      }

      try {
        const headers = {
          "Content-Type": "application/json",
          Authorization: token ? `Bearer ${token}` : undefined,
          institute_id: Number(institueId),
        };

        // If we came via URL we already fetched student parents (skip full list)
        if (isFromURL) {
          return;
        }

        const response = await axios.get(
          BASE_URL+"/parents",
          { headers }
        );
        setData(response.data.data || []);
      } catch (error) {
        toast.error(error.response?.data?.message || "Something went wrong");
      }
    };

  // main parents list (normal mode fetch)
  useEffect(() => {
   

    fetchParents();
  }, [loading, isFromURL]); // keep loading in deps so refresh works; skip when isFromURL

  useEffect(()=>{
    ApiEndpoints.getAllCourses().then((res)=>setCourses(res.data.data || []))
    .catch(console.err)
  },[])

  // when selectedCourse changes -> fetch classes
  useEffect(() => {
    const fetchClasses = async () => {
      if (!selectedCourse) {
        setClasses([]);
        setSelectedClass("");
        return;
      }
      try {
        const res = await ApiEndpoints.getAllClassesByCourseId(parseInt(selectedCourse));
        const classList = res.data.data || [];
        setClasses(classList);

        // If we came from URL and paramClassId matches one of the fetched classes, keep it
        if (isFromURL && paramClassId) {
          const found = classList.find((c) => String(c.id) === String(paramClassId));
          if (found) {
            setSelectedClass(String(paramClassId));
            return;
          }
        }

        // Otherwise reset class & students
        setSelectedClass("");
        setStudents([]);
        setSelectedStudentId("");
        setSelectedStudentFull(null);
      } catch (error) {
        console.error(error);
        toast.error("Error fetching classes.");
      }
    };

    fetchClasses();
  }, [selectedCourse, isFromURL, paramClassId]);

  // when selectedClass changes -> fetch students of that class
  useEffect(() => {
    const fetchStudentsByClass = async () => {
      if (!selectedClass) return;

      const institueId = Cookies.get("institute_id");
      const userCookie = Cookies.get("user");
      let token = null;
      if (userCookie) {
        try {
          const user = JSON.parse(userCookie);
          token = user.token;
        } catch (err) {
          console.error(" Failed to parse user cookie", err);
        }
      }

      try {
        const headers = {
          "Content-Type": "application/json",
          Authorization: token ? `Bearer ${token}` : undefined,
          institute_id: Number(institueId),
        };

        const response = await axios.get(
          BASE_URL+`/get/student/by-class?class_id=${parseInt(selectedClass)}`,
          { headers }
        );

        const studentList = response.data.data || [];
        setStudents(studentList);

        // If arriving from URL, pre-select the student (if present in list)
        if (isFromURL && paramStudentId) {
          const found = studentList.find((s) => String(s.id) === String(paramStudentId));
          if (found) {
            setSelectedStudentId(String(found.id));
            setSelectedStudentFull(found);
            // Note: parents for this student already fetched in the initial useEffect,
            // but if you want to fetch again here, you can call fetchAllParents(found.id)
          }
        }
      } catch (error) {
        toast.error(error.response?.data?.message || "Something went wrong");
      }
    };

    fetchStudentsByClass();
  }, [selectedClass, isFromURL, paramStudentId]);

 // Fetch parents for a given student ID (student-specific API)
  const fetchAllParents = async (studentId) => {
    const institueId = Cookies.get("institute_id");
    const userCookie = Cookies.get("user");
    let token = null;
    if (userCookie) {
      try {
        const user = JSON.parse(userCookie);
        token = user.token;
      } catch (err) {
        console.error("Failed to parse user cookie", err);
      }
    }

    try {
      const headers = {
        "Content-Type": "application/json",
        Authorization: token ? `Bearer ${token}` : undefined,
        institute_id: Number(institueId),
      };

      const response = await axios.get(
        BASE_URL+`/students/${studentId}/parents`,
        { headers }
      );
      console.log("Parents fetched:", response.data.parents || []);

  
      
    if (response.data.status === false) {
      setData([]);
      setErrorMessage(response.data.message || "No parent data available");
      toast.error(response.data.message || "No parent data available");
    } else {
      setData(response.data.parents || []);
      setErrorMessage(""); // ✅ clear old message
    }
    } catch (error) {
      setData([])
    setErrorMessage(error.response?.data?.message || "Something went wrong");
    }
  };



const handleStudentChange = (studentId) => {
    if (!studentId) {
      setSelectedStudentId("");
      setSelectedStudentFull(null);
      // reset to full list when no student is selected
      if (!isFromURL) {
        // reload full parents list
        setLoading((l) => !l);
      }
      return;
    }

    const fullData = students.find((std) => String(std.id) === String(studentId));
    setSelectedStudentFull(fullData || null);
    setSelectedStudentId(String(fullData?.id || ""));

    if (studentId) {
      fetchAllParents(studentId);
    }
  };


  const [newParent, setNewParent] = useState({
    name: '',
    phone_number: '',
    email: '',
    password: '',
    institute_id: '',
    confirmPassword:""
  })
  // Function to calculate age from date of birth
  const calculateAge = (dob) => {
    if (!dob) return ''
    const birthDate = new Date(dob)
    const today = new Date()
    let age = today.getFullYear() - birthDate.getFullYear()
    const monthDiff = today.getMonth() - birthDate.getMonth()

    // Adjust age if the birthday hasn't occurred yet this year
    if (
      monthDiff < 0 ||
      (monthDiff === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--
    }
    return age
  }

  // Filter Data Based on Search
  const filteredData = data?.filter((item) =>
    Object.values(item).some((value) =>
      value !== null && value !== undefined
        ? value.toString().toLowerCase().includes(search.trim().toLowerCase())
        : false,
    ),
  )

  // Pagination Logic
  const totalPages = Math.ceil(filteredData?.length / itemsPerPage) || 1
  const indexOfLastItem = currentPage * itemsPerPage
  const indexOfFirstItem = indexOfLastItem - itemsPerPage
  const currentItems = filteredData?.slice(indexOfFirstItem, indexOfLastItem)

  useEffect(() => {
  if (currentPage > totalPages) {
    setCurrentPage(1);
  }
}, [filteredData, totalPages, currentPage]);

  // useEffect(() => {
  //   if (currentPage > totalPages && totalPages !== 0) {
  //     setCurrentPage(1)
  //   }
  // }, [filteredData, totalPages])

  // Handle Form Input
  const handleInputChange = (e) => {
    const { name, value } = e.target
    setNewParent((prev) => ({ ...prev, [name]: value }))

    if (name === 'dob') {
      const age = calculateAge(value)
      setNewParent((prev) => ({
        ...prev,
        dob: value,
        age: age.toString(),
      }))
    } else {
      setNewParent((prev) => ({ ...prev, [name]: value }))
    }
  }

  
  const toggleConfirmPasswordVisibility = () =>
    setShowConfirmPassword(!showConfirmPassword);


  // Add New Parent
  const handleSave = async (e) => {
    e.preventDefault()

    if(newParent.password !== newParent.confirmPassword){
      toast.error("Password do not match")
      return
    }
    try {
      setLoading(true)

      const headers = {
        Authorization: `Bearer ${user.token}`,
      }
      const payload = {
        ...newParent,
        headers,
      }

      console.log('Sending data: ', newParent)
      const response = await ApiEndpoints.addParent({
        ...payload,
        password: newParent.password,
      })
   
      
      if (response.status === 200 || response.status === 201) {
        toast.success(response.data.message)
        setShowModal(false)
      } 
       else {
      // Dynamically get the first error from any field
      const errors = response.data.errors;
      if (errors) {
        const firstKey = Object.keys(errors)[0];
        toast.error(errors[firstKey][0]);
      } else {
        toast.error(response.data.message || "Validation failed");
      }
    }
  } catch (err) {
      
     console.error(err);

    // Handle API errors dynamically
    const errors = err.response?.data?.errors;
    if (errors) {
      const firstKey = Object.keys(errors)[0];
      toast.error(errors[firstKey][0]);
    } else {
      toast.error(err.response?.data?.message || "Something went wrong");
    }
    } finally {
      setLoading(false);
    }
  }

  const [marginLeft, setMarginLeft] = useState(
    window.innerWidth > 768 ? '300px' : '0px',
  )

  useEffect(() => {
    const handleResize = () => {
      setMarginLeft(window.innerWidth > 768 ? '270px' : '0px')
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const [showPassword, setShowPassword] = useState(false)
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword)
  }
  const handleRefresh = () => {
    // clear selected filters
    setSelectedCourse("");
    setSelectedClass("");
    setSelectedStudentId("");

    // reload all parents
    fetchParents([]);
  };

  const highlightText = (text, search) => {
    if (!search) return text

    const lowerText = text.toString().toLowerCase()
    const lowerSearch = search.toLowerCase()

    // Check if all characters from search exist in the text
    const allCharsMatch = [...lowerSearch].every((char) =>
      lowerText.includes(char),
    )

    if (!allCharsMatch) {
      // Return plain text if any character is missing
      return text
    }

    // Highlight matching characters
    return text
      .toString()
      .split('')
      .map((char, i) => {
        return lowerSearch.includes(char.toLowerCase()) ? (
          <span key={i} style={{ backgroundColor: 'yellow', color: 'black' }}>
            {char}
          </span>
        ) : (
          <span key={i}>{char}</span>
        )
      })
  }
  return (
    <div style={{ marginLeft }}>
      <div
        className="container-fluid p-0"
        style={{
          marginTop: window.innerWidth < 768 ? '55px' : '-12px',
        }}
      >
        <div className="bg-secondary p-3 rounded d-flex flex-wrap justify-content-between align-items-center text-white">
          <h2 className="m-0 ">Guardians</h2>
          <Button
            variant="light"
            className="fw-bold px-4 py-2 rounded shadow-sm d-flex align-items-center"
            onClick={() => {
             setNewParent({
              name: "",
              phone_number: "",
              email: "",
              password: "",
            });
            setShowModal(true)}}
          >
            <FaUser size={18} className="me-2" />
            Add New Guardian
          </Button>
        </div>
      </div>

      {/* <Row className="g-2 align-items-center justify-content-between mt-4">
        <Col xs={12} md={3}>
          <Form.Control
            type="text"
            placeholder="Search Guradian Name"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </Col>
        <Col xs="auto">
          <Button
            variant="outline-primary"
            onClick={handleRefresh}
            title="Refresh"
            className="w-auto"
          >
            <FaSyncAlt /> Refresh
          </Button>
        </Col>
      </Row> */}
      
      <div className="card-body p-3">
        <div className="row mb-3 text-start">
          <div className="col-md-3">
            <div className="form-group mb-2">
              <label className="form-label mb-0 fw-bold">Select Course</label>
              <select className="form-select" value={selectedCourse || ""} onChange={(e) => setSelectedCourse(e.target.value)}>
                <option value="">Select Course</option>
                {courses.map((course) => (
                  <option key={course.id} value={course.id}>{course.name}</option>
                ))}
              </select>
            </div>
          </div>

          <div className="col-md-3">
            <div className="form-group mb-2">
              <label className="form-label mb-0 fw-bold">Select Class</label>
              <select className="form-select" value={selectedClass || ""} onChange={(e) => setSelectedClass(e.target.value)}>
                <option value="">Select Class</option>
                {classes.map((cls) => (
                  <option key={cls.id} value={cls.id}>{cls.class_name}</option>
                ))}
              </select>
            </div>
          </div>

          <div className="col-md-3">
            <div className="form-group mb-2">
              <label className="form-label mb-0 fw-bold">Select Student</label>
              <select className="form-select" value={selectedStudentId || ""} onChange={(e) => handleStudentChange(e.target.value)}>
                <option value="">Select Student</option>
                {students.map((student) => (
                  <option key={student.id} value={student.id}>{student.name}</option>
                ))}
              </select>
              
            </div>
            
          </div>
          
               {/* <div className="col-md-"> */}
            <div className="form-group mt-4 col-md-3">    
               <Button
            variant="outline-primary"
            onClick={handleRefresh}
            title="Refresh"
            className="w-auto"
          >
            <FaSyncAlt /> Refresh
          </Button>
              
            {/* </div> */}
            
          </div>


        </div>
      </div>

      <div className="d-flex justify-content-end align-items-center gap-3 mb-3 mt-4">
        <p className="text-black m-0">Total Guradians: {filteredData?.length}</p>
        <Form.Select
          className="w-auto"
          value={itemsPerPage}
          onChange={(e) => {
            setItemsPerPage(parseInt(e.target.value))
            setCurrentPage(1)
          }}
        >
          <option value="10">10 per page</option>
          <option value="20">20 per page</option>
          <option value="30">30 per page</option>
        </Form.Select>
      </div>
      {/* Teacher Table */}

      <Table className="table table-striped table-bordered table-hover rounded overflow-hidden shadow-sm mb-0">
        <Thead className="bg-dark text-white">
          <Tr>
            <Th>Name</Th>
            <Th>Phone</Th>
            <Th>Email</Th>
            {/* <Th>Action</Th> */}
          </Tr>
        </Thead>
        <Tbody>
          {currentItems?.length > 0 ? (
            currentItems?.map((item, index) => (
              <Tr key={index} className="align-middle">
                <Td>{highlightText(item.name, search)}</Td>
                <Td>{item.phone_number}</Td>
                <Td>{item.email}</Td>
                {/* <Td className="text-center">
                  <div className="d-flex flex-wrap justify-content-start justify-content-md-center gap-2">
                    <Button
                      variant="info"
                      onClick={() => handleTeacherProfile(item)}
                    >
                      <Eye />
                    </Button>
                    <Button
                      variant="warning"
                      className="d-flex flex-wrap justify-content-start justify-content-md-center gap-2"
                      onClick={() => {
                        setSelectedTeacher(item)
                        setShowEditModal(true)
                      }}
                    >
                      <PencilSquare />
                    </Button>
                  </div>
                </Td> */}
              </Tr>
            ))
          ) : (
            <Tr>
              <Td colSpan="8" className="text-center text-muted fw-bold p-4">
                {errorMessage || "No records found"}
              </Td>
            </Tr>
          )}
        </Tbody>
      </Table>

      {/* Total Records */}
      <div className="d-flex justify-content-end align-items-center">
        <Pagination className="mt-2">
          <Pagination.Prev
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            disabled={currentPage === 1}
          />
          {/* {[...Array(totalPages)]?.map((_, i) => ( */}
            {Array.from({ length: Math.max(totalPages || 0, 0) }, (_, i) => (
            <Pagination.Item
              key={i}
              active={i + 1 === currentPage}
              onClick={() => setCurrentPage(i + 1)}
            >
              {i + 1}
            </Pagination.Item>
          ))}
          <Pagination.Next
            onClick={() =>
              setCurrentPage((prev) => Math.min(prev + 1, totalPages))
            }
            disabled={currentPage === totalPages}
          />
        </Pagination>
      </div>

      {/* Add New Teacher Modal */}
      <Modal
        size="lg"
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
      >
        <Modal.Header closeButton className="text-white bg-secondary">
          <Modal.Title>Add New Guardian</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSave}>
            {/* Name Field */}
            <Form.Group className="mb-3">
              <Form.Label>Name *</Form.Label>
              <Form.Control
                type="text"
                name="name"
                value={newParent.name}
                onChange={handleInputChange}
                placeholder="Enter Guardian's Name"
                className="p-2 border rounded"
                required
              />
            </Form.Group>

          {/* Phone Number Field */}
            <Form.Group className="mb-3">
              <Form.Label>Phone Number *</Form.Label>
              <Form.Control
                type="text"
                name="phone_number"
                value={newParent.phone_number}
                onChange={handleInputChange}
                placeholder="Enter Phone Number"
                className="p-2 border rounded"
                required
              />
            </Form.Group>

            {/* Email ID Field */}
            <Form.Group className="mb-3">
              <Form.Label>Email ID *</Form.Label>
              <Form.Control
                type="email"
                name="email"
                value={newParent.email}
                onChange={handleInputChange}
                placeholder="Enter Email ID"
                className="p-2 border rounded"
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Password *</Form.Label>
              <div className="input-group">
                <Form.Control
                  type={showPassword ? 'text' : 'password'}
                  name="password"
                  value={newParent.password}
                  onChange={handleInputChange}
                  placeholder="Enter Password"
                  className="p-2 border rounded"
                  required
                />
                <Button
                  variant="outline-secondary"
                  onClick={togglePasswordVisibility}
                  title={showPassword ? 'Hide Password' : 'Show Password'}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </Button>
              </div>
            </Form.Group>

              <Form.Group className="mb-3">
        <Form.Label>Re-enter Password *</Form.Label>
        <div className="input-group">
          <Form.Control
            type={showConfirmPassword ? "text" : "password"}
            name="confirmPassword"
            value={newParent.confirmPassword}
            onChange={handleInputChange}
            placeholder="Re-enter Password"
            className="p-2 border rounded"
            required
          />
          <Button
            variant="outline-secondary"
            onClick={toggleConfirmPasswordVisibility}
            type="button"
            title={showConfirmPassword ? "Hide Password" : "Show Password"}
          >
            {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
          </Button>
        </div>
      </Form.Group>


            <Modal.Footer>
              <Button variant="danger" onClick={() => setShowModal(false)}>
                Cancel
              </Button>
              <Button variant="success" type="submit">
                Save Guardian
              </Button>
            </Modal.Footer>
          </Form>
        </Modal.Body>
      </Modal>
      <EditTeacherModal
        show={showEditModal}
        handleClose={() => setShowEditModal(false)}
        teacher={selectedTeacher}
      />
    </div>
  )
}

export default GuardianTable
